<script setup>
import {inject} from "vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();

const showProfile = inject('showProfile');
const logout = inject('logout');
</script>

<template>
    <b-dropdown v-if="store.state.user.id" id="topbar__dropdown" right text="" class="topbar__dropdown">
        <b-dropdown-item @click="showProfile" class="topbar__dropdown__apply">My profile</b-dropdown-item>
        <b-dropdown-item href="/" class="topbar__dropdown__company">My Company</b-dropdown-item>
        <b-dropdown-item href="/enterprises" class="topbar__dropdown__enterprises">Enterprises</b-dropdown-item>
        <b-dropdown-item href="/public-trackers" class="topbar__dropdown__apply">Apply To Challenge</b-dropdown-item>
        <b-dropdown-item href="/team" class="topbar__dropdown__apply">Team</b-dropdown-item>
        <b-dropdown-item @click="logout" class="topbar__dropdown__apply">Sign Out</b-dropdown-item>
    </b-dropdown>
</template>

<style scoped>

</style>
